/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default [
  {
    url: null,
    name: "Mi Perfil",
    slug: "Mi Perfil",
    icon: "UserIcon",
    i18n: "Mi Perfil",
    // tag:"New",
    // tagColor:"green",
    submenu: [
      {
        url: '/alumnos/datos',
        name: "Mis datos",
        slug: "misDatos",
        i18n: "Mis datos",
      },
     ]
  },
  {
    url: null,
    name: "Servicios escolares",
    slug: "alumnos",
    icon: "CheckSquareIcon",
    i18n: "Servicios escolares",
    submenu: [
     
      {
        url: '/alumnos/pagos',
        name: "Pagos",
        slug: "pagos",
        i18n: "Pagos",
      },
      /*{
        url: '/alumnos/kardex',
        name: "Kardex",
        slug: "kardex",
        i18n: "Kardex",
      },*/
    /*  {
        url: '/alumnos/inscripcion',
        name: "Inscripción",
        slug: "inscripcion",
        i18n: "Inscripción",
      },*/
      {
        url: '/alumnos/kardex',
        name: "Kardex",
        slug: "kardex",
        i18n: "Kardex",
      },
      {
        url: '/alumnos/calendarioescolar',
        name: "Calendario Escolar",
        slug: "calendarioEscolar",
        i18n: "Calendario Escolar",
      },
    ]
  },

  {
    url: null,
    name: "Boletas Calificaciones",
    slug: "BoletaCalificaciones",
    icon: "ListIcon",
    i18n: "BoletasCalificaciones",
    //  tag:"New",
    //  tagColor:"green",
   
    submenu: [
      {
        url: '/alumnos/boletacalificaciones',
        name: "BoletaCalificaciones",
        slug: "BoletaCalificaciones",
        i18n: "Boletas",
      }

    ]
  },

  {
    url: null,
    name: "Cuatrimestre Actual",
    slug: "cuatrimestreActual",
    icon: "FileTextIcon",
    i18n: "Cuatrimestre Actual",
    submenu: [
      {
        url: '/alumnos/cargaAcademica',
        name: "CargaAcademica",
        slug: "CargaAcademica",
        i18n: "CargaAcadémica",
        // tag:"New",
        // tagColor:"green",
      },
      {
        url: '/alumnos/calificaciones',
        name: "Calificaciones",
        slug: "calificaciones",
        i18n: "Calificaciones",
      }
      // {
      //   url: '/alumnos/cargadematerias',
      //   name: "Carga de materias",
      //   slug: "cargaDeMaterias",
      //   i18n: "Carga de materias",
      // },
      /*{
        url: '/alumnos/kardex',
        name: "Kardex",
        slug: "kardex",
        i18n: "Kardex",
      },*/

      // {
      //     url: '/alumnos/inscripcion',
      //     name: "Inscripción",
      //     slug: "inscripcion",
      //     i18n: "Inscripción",
      //   },
      

    ]
  },
 

  {
    url: null,
    name: "Re-Inscripcion",
    slug: "Re-Inscripcion",
    // icon: "UploadCloudIcon",
     icon: "RepeatIcon",    
    i18n: "Re-Inscripción",
    // tag:"New",
    // tagColor:"blue",
    submenu: [
         {
            url: '/alumnos/inscripcion',
            name: "Inscripción",
            slug: "inscripcion",
            i18n: "CargaDeMaterias",
    //     tag:"New",
    // tagColor:"green",
         }
        //  ,
          // {
          //   url: '/alumnos/descargadematerias',
          //   name: "Descarga de materias",
          //   slug: "descargaDeMaterias",
          //   i18n: "Descarga de materias",
          // }
        ]
       },


       {
        url: null,
        name: "descargaDeMaterias",
        slug: "descargaDeMaterias",
        icon: "DownloadIcon",
        i18n: "DescargaDeMaterias",
        submenu: [
               {
                url: '/alumnos/descargadematerias',
                name: "Descarga de materias",
                slug: "descargaDeMaterias",
                i18n: "Descarga",
                // tag:"New",
                // tagColor:"red",
              }
            ]
           },

       {
        url: null,
        name: "Horario",
        slug: "Horario",
        icon: "ClockIcon",
        i18n: "Horario",
        submenu: [
            
              {
                url: '/alumnos/horario',
                name: "Horario",
                slug: "horario",
                i18n: "Horario",
                // tag:"New",
                // tagColor:"orange",
              }
            ]
           },

           {
            url: null,
            name: "Manuales",
            slug: "Manuales",
            icon: "BookOpenIcon",
            i18n: "Manual de Usuario",
            // tag:"New",
            // tagColor:"orange",
            submenu: [
                
                  {
                    url: '/alumnos/tutos_manual_usuario',
                    name: "Manuales",
                    slug: "Manuales",
                    i18n: "Manual SAE",
                    tag:"New",
                    tagColor:"orange",
                  }
                ]
               }


       
 ]
